import { CookieAttributes } from 'js-cookie';
import { LocalCache } from './LocalCache';
import Cookies from './Cookies';
export * from './LocalCache';

export function createCookies<T extends object = object>(options?: CookieAttributes): LocalCache<T> {
  return Cookies.create<T>(options);
}
